<template>
    <div>
        <!-- Users Grid -->
        <div v-if="!isLoading" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
            <UserCard v-for="user in users" :key="user.id" :user="user" @view-user="$emit('view-user', $event)"
                @edit-user="$emit('edit-user', $event)" @impersonate-user="$emit('impersonate-user', $event)" />
        </div>

        <!-- No Users Found -->
        <div v-if="!isLoading && users.length === 0" class="text-center py-12">
            <div class="text-gray-500">
                <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                </svg>
                <h3 class="mt-2 text-sm font-medium text-gray-900">No users found</h3>
                <p class="mt-1 text-sm text-gray-500">Try adjusting your search or filter criteria.</p>
            </div>
        </div>
    </div>
</template>

<script>
import UserCard from './UserCard.vue';

export default {
    name: "UserGrid",
    components: {
        UserCard,
    },
    props: {
        users: {
            type: Array,
            default: () => []
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
};
</script>
